// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QSvz","list":"styles_list__3DhQR","disableSelection":"styles_disableSelection__VyxFW"};